import { createSlice } from "@reduxjs/toolkit";


export const initialState = {
    plans: JSON.parse(localStorage.getItem('PLANS')) || [],
    markets: JSON.parse(localStorage.getItem('MARKETS')) || [],
    coverageCompetitions: JSON.parse(localStorage.getItem('COVERAGE_COMPETITIONS')) || [],
};


export const utilitySlice = createSlice({
    name: 'Utility',
    initialState,
    reducers: {
        setPlans: (state, action) => {
            state.plans = action.payload;
            localStorage.setItem('PLANS', JSON.stringify(action.payload));
        },
        setMarkets: (state, action) => {
            state.markets = action.payload;
            localStorage.setItem('MARKETS', JSON.stringify(action.payload));
        },
        setCoverageCompetitions: (state, action) => {
            state.coverageCompetitions = action.payload;
            localStorage.setItem('COVERAGE_COMPETITIONS', JSON.stringify(action.payload));
        },
        resetUtility: (state) => {
            state.plans = [];
            state.markets = [];
            state.coverageCompetitions = [];
            localStorage.removeItem('PLANS');
            localStorage.removeItem('MARKETS');
            localStorage.removeItem('COVERAGE_COMPETITIONS');
        },
    },
});

export const { setPlans, setMarkets, setCoverageCompetitions, resetUtility } = utilitySlice.actions;


export default utilitySlice.reducer;